module.exports = __webpack_public_path__ + "img/idcard_input.3ca31f2e.svg";